import React from 'react';

const IconRomania = props => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 55.2 38.4"
      {...props}
    >
      <g>
        <path
          fill="#002B7F"
          d="M17.75,0v38.4H3.03C1.37,38.4,0,37.04,0,35.37V3.03C0,1.36,1.37,0,3.03,0H17.75L17.75,0z"
        />
        <polygon fill="#FCD116" points="37.45,0 37.45,38.4 17.75,38.4 17.75,0 37.45,0" />
        <path
          fill="#CE1126"
          d="M37.45,38.4V0h14.72c1.67,0,3.03,1.36,3.03,3.03v32.33c0,1.67-1.37,3.03-3.03,3.03H37.45L37.45,38.4z"
        />
      </g>
    </svg>
  );
};

export default IconRomania;
